import userEvent from '@testing-library/user-event';

const md5 = require('md5');

const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
}

export class Authenticator {

    constructor() {
        this.user = null;
        this.endpoint = "/"
    }

    /**
     * 
     * @param {*} email 
     * @param {*} password 
     * @returns User object
     */
    async signUp(email, password, payload) {
        const salt = 'randomsalt'
        const hashedPassword = md5(salt+password)
        const user =  { ...payload, salt, email, user:email, hashedPassword };

        const res = await fetch(`/user`, {
            method: 'POST',
            headers,
            body: JSON.stringify(user)
        });
        if (res.ok) {
            const result = await res.json();
            console.log("signup repononse", result)
            this.user = result;
        }
        return this.user;

    }

    async confirmSignUp(user, code) {
        return this.user;
    }

    async resendConfirmationCode(user) {
    }

    async signIn(email, password) {
        const salt = 'randomsalt'
        const hashedPassword = md5(salt+password);
        const user = { username: email, email, hashedPassword }
        this.user = null;
        const res = await fetch(`/login`, {
            method: 'POST',
            headers,
            body: JSON.stringify(user, null, 2)
        });
        if (res.ok) {
            const result = await res.json();
            //console.log("signin repononse", result)
            this.user = result;
        }
        return this.user;
    }

    async loadUserFromBackend() { 
        this.user = null;

        const res = await fetch(`/oauth/whoami`, {
            headers,
        });
        if (res.ok) {
            const user = await res.json();
            //console.log("session user", user)
            this.user = user;
            return userEvent;
        }
        return null;        
    }

    async loadSession() {
        this.user = null;

        const res = await fetch(`/api/loadSession`, {
            headers,
        });
        if (res.ok) {
            const response = await res.json();
            const user = response.user;
            const data = response.data;
            //console.log("session user", user)
            this.user = user;
            this.data = data;
            return response;
        }
        return null;
    }

    async signOut() {
        await fetch(`/logout`, {
        }).then(res => {
            console.log("logged out", res)
        });
    }

}


const authenticator = new Authenticator();

export default authenticator;
